export default {
  title: 'Rezerwacje CSV',
  buttons: {
    generate: 'Generuj i pobierz',
  },
  fields: {
    date_range: 'Zakres dat (opcjonalnie)',
  },
  errors: {
    invalid_date_range: 'Wybierz prawidłowy zakres dat',
  },
};
